import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Typography,
  Box,
} from "@material-ui/core";
import { toast } from "react-toastify";

const TIPOS = [
  {
    v: "link",
    t: "Link de pagamento",
    rotulo: "Link",
    ex: "https://pagamento.seusite.com/abc123",
    dica: "O cliente toca no link e abre a página de pagamento.",
  },
  {
    v: "boleto",
    t: "Boleto (linha digitável)",
    rotulo: "Linha digitável",
    ex: "34191.79001 01043.510047 91020.150008 1 84670000002000",
    dica: "O número que o cliente cola no aplicativo do banco para pagar.",
  },
  {
    v: "codigo",
    t: "Outro código",
    rotulo: "Código",
    ex: "",
    dica: "Qualquer código que o cliente precise copiar.",
  },
];

const FlowBuilderPayLinkModal = ({ open, onSave, onUpdate, data, close }) => {
  const [activeModal, setActiveModal] = useState(false);
  const [tipo, setTipo] = useState("link");
  const [conteudo, setConteudo] = useState("");
  const [valor, setValor] = useState("");
  const [nomeRecebedor, setNomeRecebedor] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [comoFunciona, setComoFunciona] = useState(false);

  const tipoAtual = TIPOS.find((t) => t.v === tipo) || TIPOS[0];

  useEffect(() => {
    if (open === "edit") {
      const d = data?.data || data || {};
      setTipo(d.tipo || "link");
      setConteudo(d.conteudo || "");
      setValor(d.valor || "");
      setNomeRecebedor(d.nomeRecebedor || "");
      setMensagem(d.mensagem || "");
      setComoFunciona(false);
      setActiveModal(true);
    } else if (open === "create") {
      setTipo("link");
      setConteudo("");
      setValor("");
      setNomeRecebedor("");
      setMensagem("");
      setComoFunciona(false);
      setActiveModal(true);
    }
  }, [open, data]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSave = () => {
    const c = String(conteudo || "").trim();
    if (!c) {
      toast.error("Informe o que vai ser enviado.");
      return;
    }
    const temVariavel = /\{\{.+\}\}/.test(c);
    if (tipo === "link" && !temVariavel && !/^https?:\/\//i.test(c)) {
      toast.error("O link precisa começar com http:// ou https://");
      return;
    }
    if (tipo === "boleto" && !temVariavel) {
      const d = c.replace(/[^\d]/g, "");
      if (d.length !== 47 && d.length !== 48) {
        toast.error("A linha digitável do boleto tem 47 ou 48 dígitos.");
        return;
      }
    }
    const payload = {
      tipo,
      conteudo: c,
      valor: String(valor).trim(),
      nomeRecebedor: nomeRecebedor.trim(),
      mensagem: mensagem.trim(),
    };
    if (open === "edit") {
      onUpdate({ ...data, data: { ...(data?.data || {}), ...payload } });
    } else {
      onSave(payload);
    }
    handleClose();
  };

  const rotulo = {
    fontSize: 13,
    fontWeight: 600,
    color: "#374151",
    marginBottom: 6,
    display: "block",
  };
  const dica = {
    fontSize: 11.5,
    color: "#6b7280",
    display: "block",
    marginTop: 6,
    lineHeight: 1.5,
  };
  const alerta = {
    fontSize: 11.5,
    color: "#b45309",
    display: "block",
    marginTop: 4,
    lineHeight: 1.5,
    fontWeight: 500,
  };

  return (
    <Dialog open={activeModal} onClose={handleClose} maxWidth="xs" fullWidth scroll="paper">
      <DialogTitle>
        {open === "create" ? "Adicionar link ou boleto" : "Editar link ou boleto"}
      </DialogTitle>
      <DialogContent dividers>
        <Box
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: 12,
            padding: 16,
            marginBottom: 14,
          }}
        >
          <Typography style={rotulo}>O que enviar *</Typography>
          <TextField
            select
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
            fullWidth
            size="small"
            variant="outlined"
          >
            {TIPOS.map((t) => (
              <MenuItem key={t.v} value={t.v}>
                {t.t}
              </MenuItem>
            ))}
          </TextField>

          <Typography style={{ ...rotulo, marginTop: 18 }}>
            {tipoAtual.rotulo} *
          </Typography>
          <TextField
            value={conteudo}
            onChange={(e) => setConteudo(e.target.value)}
            fullWidth
            multiline
            minRows={2}
            size="small"
            variant="outlined"
            placeholder={tipoAtual.ex}
          />
          <Typography style={dica}>
            {tipoAtual.dica} Aceita variável do fluxo, ex.:{" "}
            <b>{"{{link_pagamento}}"}</b>
          </Typography>

          {tipo === "boleto" && (
            <>
              <Typography style={{ ...rotulo, marginTop: 18 }}>Valor (R$)</Typography>
              <TextField
                value={valor}
                onChange={(e) => setValor(e.target.value)}
                fullWidth
                size="small"
                variant="outlined"
                placeholder="Ex: 149,90"
              />
              <Typography style={alerta}>
                Com valor preenchido, no canal oficial vai como cartão (valor em
                destaque + botão "Copiar código do boleto"). Sem valor, vai como texto.
              </Typography>

              <Typography style={{ ...rotulo, marginTop: 18 }}>
                Nome de quem cobra
              </Typography>
              <TextField
                value={nomeRecebedor}
                onChange={(e) => setNomeRecebedor(e.target.value)}
                fullWidth
                size="small"
                variant="outlined"
                placeholder="Nome que aparece no cartão"
                inputProps={{ maxLength: 25 }}
              />

              <Typography style={{ ...rotulo, marginTop: 18 }}>
                Mensagem do cartão
              </Typography>
              <TextField
                value={mensagem}
                onChange={(e) => setMensagem(e.target.value)}
                fullWidth
                size="small"
                variant="outlined"
                placeholder="Segue o boleto para pagamento"
              />
            </>
          )}
        </Box>

        <Box style={{ border: "1px solid #e5e7eb", borderRadius: 12, padding: 14 }}>
          <Box
            onClick={() => setComoFunciona((v) => !v)}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography style={{ fontSize: 13, fontWeight: 700, color: "#374151" }}>
              Como funciona
            </Typography>
            <Typography style={{ fontSize: 12, color: "#6b7280" }}>
              {comoFunciona ? "ocultar" : "mostrar"}
            </Typography>
          </Box>

          {comoFunciona && (
            <Box style={{ marginTop: 10 }}>
              <Typography style={{ fontSize: 12, color: "#4b5563", lineHeight: 1.65 }}>
                Este bloco manda o link ou o número para o cliente copiar e colar. Serve
                para cartão, boleto ou qualquer cobrança de gateway. Funciona nas
                conexões padrão e na integração oficial — não depende de liberação da
                Meta.
              </Typography>
              <Typography style={{ ...alerta, marginTop: 10 }}>
                Vai sozinho, numa mensagem separada. Isso é de propósito: no WhatsApp um
                toque copia a mensagem inteira — se tivesse texto junto, viria lixo
                grudado no código. Coloque sua explicação num bloco de texto antes deste.
              </Typography>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderPayLinkModal;
